export interface IAdvanceRatePeriod {
	id: number
	date_from: string
	date_to: string
	rate: number
}

export interface IAdvanceRatePeriodPayload {
	date_from: string
	date_to: string
	rate: number
}

const groupPrefix = 'advance-rate-periods'

export const apiAdvanceRatePeriods = {
	fetchAdvanceRatePeriods: async () => {
		const { data } = await apiCommon<IAdvanceRatePeriod[]>(groupPrefix, { method: 'GET' })
		return data ?? []
	},

	createAdvanceRatePeriod: async (payload: IAdvanceRatePeriodPayload) => {
		const { data } = await apiCommon<IAdvanceRatePeriod>(groupPrefix, { method: 'POST', body: payload })
		return data
	},

	updateAdvanceRatePeriod: async (advanceRatePeriodID: number | string, payload: IAdvanceRatePeriodPayload) => {
		const { data } = await apiCommon<IAdvanceRatePeriod>(`${groupPrefix}/${advanceRatePeriodID}`, { method: 'PUT', body: payload })
		return data
	},

	deleteAdvanceRatePeriod: async (advanceRatePeriodID: number | string) => {
		return await apiCommon<string>(`${groupPrefix}/${advanceRatePeriodID}`, { method: 'DELETE' })
	},
}
